import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MenuStore } from '../service/menu.store';
import { OnyxEvent } from '../../event/models/event';
import { EventStore } from '../../event/service/event.store';
import { EventSearchParametersStore } from '../../event/service/event-search-parameters.store';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { InvoiceHistoryStore } from 'app/event/service/invoice-history.store';

@Component({
  selector: 'pioneer-event-menu',
  templateUrl: './event-menu.component.html'
})
export class EventMenuComponent implements OnInit, OnDestroy {

  public eventTitle = 'COMMON.NAV.EVENT_INFORMATION';
  public includeSubNav = true;
  public showInvoiceHistory = false;

  private _destroyed$ = new Subject<void>();

  private _links$ = new BehaviorSubject<{ [key: string]: string }>(undefined);
  links$ = this._links$.asObservable();

  constructor(
    private eventStore: EventStore,
    private menuStore: MenuStore,
    private eventSearchParameterStore: EventSearchParametersStore,
    private authenticationStore: AuthenticationStore,
    private cdRef: ChangeDetectorRef,
    private invoiceHistoryStore: InvoiceHistoryStore
  ) { }

  ngOnInit() {
    this.menuStore.isReadOnly.pipe(
      takeUntil(this._destroyed$),
      tap((isReadOnly: boolean) => {
        this.includeSubNav = isReadOnly;
        this.eventTitle = isReadOnly ? 'COMMON.NAV.EVENT_INFORMATION' : 'COMMON.NAV.EDIT_EVENT';
        this.cdRef.detectChanges();
      })
    ).subscribe();

    this.invoiceHistoryStore.getInvoiceHistoryEnabled().pipe(
      takeUntil(this._destroyed$)
    ).subscribe((enabled: boolean) => {
      this.showInvoiceHistory = enabled;
    });

    this.eventStore.selectedEvent.pipe(
      takeUntil(this._destroyed$),
      tap((onyxEvent: OnyxEvent) => {
        this._links$.next(this.getLinks(onyxEvent));
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  navigateToSearch(): void {
    this.eventSearchParameterStore.updateUrl();
  }

  private getLinks(onyxEvent: OnyxEvent) {
    let links = undefined;

    if (onyxEvent) {
      let eventLink: string;
      if (this.authenticationStore.isMultiVendor()) {
        eventLink = '' + onyxEvent.eventId;
      } else if (onyxEvent.eventProperty) {
        eventLink = onyxEvent.eventId + '/' + onyxEvent.eventProperty.eventPartyId;
      }
      if (eventLink) {
        links = {
          overview: '/event/' + eventLink + '/overview',
          summary: '/event/' + eventLink + '/summary',
          rsvps: '/event/' + eventLink + '/rsvp',
          transientReservations: '/event/' + eventLink + '/transient-reservations',
          commission: '/event/' + eventLink + '/commission',
          invoiceHistory: '/event/' + eventLink + '/invoice-history'
        };
        if (onyxEvent.eventProperty && onyxEvent.eventProperty.subscriber) {
          links.reservations = '/event/' + eventLink + '/reservations';
        }
      }
    }
    return links;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/event-menu/event-menu.component.ts